<template>
    <transition name="bs-nav__notification-slide">
        <div
            v-show="menuNotificationVisible"
            class="bs-nav__notification"
        >
            <p
                @click="handleNotificationLinks($event)"
                v-html="text"
            >
            </p>
            <div
                class="bs-nav__notification__button"
                tabindex="-1"
                @click="handleDismissNotification(id,dismiss)"
                @keydown.prevent.space="handleDismissNotification(id,dismiss)"
            >
                <v-icon
                    v-if="type === 'info'"
                    size="large"
                    class="bs-nav__notification__button--icon"
                    :class="{'bs-nav__notification__button--icon--no-dismiss':!isDismissable}"
                >
                    bs:$vuetify.icons.mdiBell
                </v-icon>
                <v-icon
                    v-if="type === 'warning'"
                    size="large"
                    class="bs-nav__notification__button--icon"
                    :class="{'bs-nav__notification__button--icon--no-dismiss':!isDismissable}"
                >
                    bs:$vuetify.icons.mdiBellAlert
                </v-icon>
                <v-icon
                    v-if="type === 'donation'"
                    size="large"
                    class="bs-nav__notification__button--icon"
                    :class="{'bs-nav__notification__button--icon--no-dismiss':!isDismissable}"
                >
                    bs:$vuetify.icons.mdiBellRing
                </v-icon>
                <v-icon
                    size="large"
                    class="bs-nav__notification__button--icon bs-nav__notification__button--icon-close"
                    :class="{'bs-nav__notification__button--icon-close--no-dismiss':!isDismissable}"
                >
                    bs:$vuetify.icons.mdiClose
                </v-icon>
            </div>
        </div>
    </transition>
</template>

<script>
import {getActivePinia, storeToRefs} from 'pinia'
import {useDismissNotification,} from '@/assets/js/src/util/composables/useDismissNotification'
import {useAppUiStore,} from '@/assets/js/src/pinia/appUi'

export default {
    name: 'MenuNotification',
    setup() {
        let activePinia = getActivePinia()

        const appUiStore = useAppUiStore(activePinia)
        const {menuNotificationVisible, notification,} = storeToRefs(appUiStore)

        return {
            menuNotificationVisible,
            notification,
            ...useDismissNotification(),
        }
    },
    data: () => ({
        isDismissable: false,
        id: 0,
        dismiss: null,
        text: '',
        type: '',
        isReadingPlan: false,
    }),
    watch: {
        notification: function (newVal) {
            // Notification laden
            if (typeof newVal !== 'undefined' && typeof newVal.id !== 'undefined') {
                this.id = newVal.id
                this.dismiss = newVal.dismiss_days || null
                this.text = newVal.notification_message.message.replace('<a', '<a tabindex="-1"')
                this.type = newVal.type
                this.isDismissable = typeof newVal.dismiss_days !== 'undefined'
                this.isReadingPlan = newVal.id === 0
                this.isDismissable = this.isDismissable || this.isReadingPlan
                this.menuNotificationVisible = true

                return
            }

            this.id = 0
            this.menuNotificationVisible = false
        },
    },
    methods: {
        async handleDismissNotification(id, dismiss) {
            if (!this.isDismissable && id) {
                return
            }

            await this.dismissNotification({
                id,
                dismiss,
                readingPlan: this.isReadingPlan,
            })
        },
        handleNotificationLinks(event) {
            let {target,} = event
            while (target && target.tagName !== 'A') target = target.parentNode
            if (target) {
                let link = target.href
                let origin = location.origin

                if (link.indexOf(origin) !== -1 || (link.indexOf('http') === -1 && link.indexOf('mailto') === -1)) {
                    event.preventDefault()
                    if (link.replace(origin, '') !== '') {
                        this.$router.push({path: link.replace(origin, ''),})
                    } else {
                        this.$router.push({path: '/',})
                    }
                }
            }
        },
    },
}
</script>

<style lang="scss">
.bs-app .bs-nav {
    &__notification {
        position: relative;
        margin-top: 32px;

        @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
            width: 100%;
            margin: 0;
            padding: 16px 54px 16px 24px;
            background: map-deep-get($bs-color, sidebar, greyDark);
            border-top: 1px solid map-deep-get($bs-color, greyDark);
        }

        &-slide-enter-from, &-slide-leave-to {
            max-height: 0;
            margin-top: 0;
            padding: 0;
            overflow: hidden;
        }

        &-slide-enter-active, &-slide-leave-active {
            transition: .3s cubic-bezier(.25, .8, .5, 1);
        }

        &-slide-enter-to, &-slide-leave-from {
            max-height: 200px;
            margin-top: 32px;
        }

        p {
            max-width: 250px;
            max-height: 72px;
            margin: 0;
            padding: 0;
            overflow: hidden;
            color: var(--bs-color-highlight);
            font-weight: 900;
            font-size: 16px;
            text-align: right;
            text-transform: uppercase;

            @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
                max-width: none;
                text-align: left;
            }
        }

        a, a:hover, a:focus {
            color: var(--bs-color-highlight);
            text-decoration: none;
            outline: none;
        }

        &__button {
            position: absolute;
            top: 50%;
            right: -48px;
            width: 24px;
            height: 24px;
            overflow: hidden;
            transform: translateY(-50%);
            cursor: pointer;

            @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
                right: 24px;
            }

            &--icon {
                position: absolute;
                top: 50%;
                left: 50%;
                color: var(--bs-color-highlight);
                transform: translate(-50%, -50%);
            }

            &--icon-close {
                @include cache((
                    opacity: 0,
                ));
            }

            &:hover, &:focus {
                outline: none;

                .bs-nav__notification__button--icon {
                    @include cache((
                        opacity: 0,
                    ));
                }

                .bs-nav__notification__button--icon--no-dismiss {
                    @include cache((
                        opacity: 1,
                    ));
                }

                .bs-nav__notification__button--icon-close {
                    @include cache((
                        opacity: 1,
                    ));
                }

                .bs-nav__notification__button--icon-close--no-dismiss {
                    @include cache((
                        opacity: 0,
                    ));
                }
            }
        }
    }
}
</style>
